import api from './api'
import auth from '_helpers/authHelper'

export const login = (params) => api().post('auth/login', params)

export const logout = () => {
  auth.setAccessToken(null)
  return api().post('auth/logout')
}

export const ping = () => api().get('ping')

export const getCurrentUser = () => api().get('users/me')

export const getCompanyAclJson = () => api().get('users/acl_json')
